module.exports = __webpack_public_path__ + "img/record.88a5d998.svg";